import { Container, Row, Col, Image} from "react-bootstrap";
import { Link } from "react-router-dom";
import {
    PressBanner,
    PressVideoSection,
    GreatNonprofitsNews,
    NewsDescription,
    VideoSection,
    NewTitle,
    NewSmallText,
    NewText,
    NewsList,
    CardRate,
    PressText,
    PressSpan,
    CardTitle, 
} from'./pressStyle';
import { 
    Title,
    WriteReviewSection,
    ReviewText,
    ReviewRightSection,
    RightBanner,
 } from "../../../components/common/commonSubBanner/commonSubBannerStyle";
import ReviewImage from "../../../assests/images/press-banner.webp";
import { useSelector,useDispatch } from "react-redux";
import { useEffect } from "react";
import { pressMediaHandler } from "../../../redux/slices/pressMedia/press-media";
import moment from "moment";
import { MESSAGE } from "../../../utils/message";
import MetaComponent from "../../../components/common/metaComponent";
 
const Press = () => {
    const dispatch:any = useDispatch()
    const pressMediaData = useSelector((state:any) => state?.pressMedia?.data?.data)

    useEffect(() => {
        dispatch(pressMediaHandler())
    },[])
    
    return (
        <>
        <MetaComponent 
            keywords=""
            description=""
            ogTitle="Press & Media Coverage | GreatNonprofits"
            ogDescription=""
            ogUrl="https://www.about.greatnonprofits.org/press"
            ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
        />
         <>
        <PressBanner>
            <WriteReviewSection className="press-banner">
                <Container className="cont-w"> 
                    <Row>
                        <Col lg={6} sm={12} md={12}>
                            <Title>{MESSAGE.pressMedia}</Title>
                            <ReviewText><strong className="media-strong">Media Contact:</strong></ReviewText>
                            <ReviewText>Perla Ni</ReviewText>
                            <ReviewText onClick={() => window.open("mailto:perlani@greatnonprofits.org")}>perlani@greatnonprofits.org</ReviewText>
                            <ReviewText onClick={() => window.open("tel:6502493792")}>(650) 249-3792 </ReviewText>
                        </Col>
                            <Col lg={6} sm={12} md={12}>
                                <RightBanner className="left_banner">
                                <ReviewRightSection className="member-board">
                                    <Image src={ReviewImage} alt="ReviewImage"/>
                            </ReviewRightSection>
                                </RightBanner>
                            </Col>
                    </Row>
                </Container>
            </WriteReviewSection>
         </PressBanner>

        <PressVideoSection>
          <Container className="cont-w">
              <GreatNonprofitsNews>
              <NewsDescription>
                  <NewTitle>{pressMediaData?.pressNews?.headline}</NewTitle>
                   <NewSmallText>{moment(pressMediaData?.pressNews?.releaseDate).format("MMM D, YYYY")}</NewSmallText>
                   <NewText>{pressMediaData?.pressNews?.description}</NewText>
              </NewsDescription>
               <VideoSection>
                   <iframe width="100%" height="315" src="https://www.youtube.com/embed/CHW_blJJg-o?si=EalzgUyw0Rj5vb87" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
               </VideoSection>
              </GreatNonprofitsNews>
               <NewsList>
                  {pressMediaData?.pressList.map((detail:any, index:number) => (
                        <CardRate key={index+1}>
                        <Link to="/" target="_blank" className="press-title">{detail.website}</Link>
                        <PressText>{detail.description}</PressText>
                        <PressSpan>{moment(detail.releaseDate).format("MMM D, YYYY")}</PressSpan>
                        </CardRate>
                  ))}
               </NewsList>
               <NewsList>
                    <CardTitle>{MESSAGE.pressRelease}</CardTitle>
                  {pressMediaData?.upComingPressReleaseList.map((detail:any, index:number) => (
                        <CardRate key={index+1}>
                        <Link to="/" target="_blank" className="press-title">{detail.headline}</Link>
                        <div>
                            <PressSpan>{moment(detail.releaseDate).format("MMM D, YYYY")}</PressSpan>
                        </div>
                        </CardRate>
                  ))}
                </NewsList>
            </Container>
       </PressVideoSection>
    </>
        </>
   
    )
};
export default Press;